export const defaults = {
  baseUrl: '',
  cache: 'no-cache',
  credentials: 'same-origin',
  debug: false,
  fit: (json) => {
    if (!json.code || json.code === 0) {
      return json.data
    } else {
      const err = new Error(json.message) // + `(${json.code})`
      err.code = +json.code
      throw err
    }
  },
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  mode: 'same-origin'
}

export function request (method, url, body, options) {
  let userInfo = JSON.parse(localStorage.getItem('userInfo'))
  if (options === void 0) { options = {} }
  if (!/^http(s)?:\/\//i.test(url)) {
    url = defaults.baseUrl.replace(/\/$/, '') + '/' + url.replace(/^\//, '')
  }
  defaults.debug && console.log(method, url)
  var headers = Object.assign({}, defaults.headers, options.headers, userInfo && userInfo.token ? {'MEMBER-TOKEN': userInfo.token} : {})
  var cache = options.cache || defaults.cache
  // when use whatwg-fetch polyfill, set cache
  if (fetch.polyfill && cache !== 'default' && !headers['cache-control'] && !headers['Cache-Control']) {
    switch (cache) {
      case 'no-store':
        headers['cache-control'] = 'no-store'
        headers.pragma = 'no-store'
        break
      default:
        headers['cache-control'] = 'no-cache'
        headers.pragma = 'no-cache'
    }
  }
  return fetch(url, {
    body: body,
    cache: cache,
    credentials: options.credentials || defaults.credentials,
    headers: headers,
    method: method,
    mode: options.mode || defaults.mode
  }).then(function (response) {
    return response.json().then(function (json) {
      if (json.code == 0) {
        return (options.fit || defaults.fit)(json, response)
      } else {
        if (json.code == '40101') {
          location.replace('/')
        }
        const error = new Error(json.msg)
        error.code = response.status
        return Promise.reject(error)
      }
    })
  })
}
export function get (url, query, options) {
  if (query === void 0) { query = {} }
  url += '?' + Object.keys(query).map(function (k) { return k + '=' + query[k] }).join('&')
  return request('get', url, undefined, options)
}
export function put (url, body, options) {
  return request('put', url, JSON.stringify(body), options)
}
export function post (url, body, options) {
  return request('post', url, JSON.stringify(body), options)
}
export function del (url, options) {
  return request('delete', url, undefined, options)
}



// WEBPACK FOOTER //
// ./src/utils/rest.js